import { BiDollarCircle, BiTrash } from 'react-icons/bi'
import { FiCopy } from 'react-icons/fi'
import { RiExchangeDollarLine } from 'react-icons/ri'
import { useNavigate } from 'react-router-dom'
import { TablePaymentLinks } from './styles'

import { cnpjCpfMask, parseDate } from '../../utils/masks'
import toast from 'react-hot-toast'
import dayjs from '../../libs/dayjs'
import { HiOutlineReceiptPercent } from 'react-icons/hi2'
import api from '../../services/axios'
import { get } from 'lodash'
import swal from 'sweetalert'
import { useSelector } from 'react-redux'
import { StoreState } from '../../store'
import React, { FormEvent, useState } from 'react'
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Slide,
} from '@mui/material'
import { TransitionProps } from '@mui/material/transitions'
import { BiLoaderAlt } from 'react-icons/bi'
import { BsTrash2 } from 'react-icons/bs'
import { fakerAPI } from '../../utils/faker-api'

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>
    },
    ref: React.Ref<unknown>
) {
    return <Slide direction="up" ref={ref} {...props} />
})

interface Props {
    myPaymentLinks: any[]
    getMyPaymentsLinks: () => Promise<void>
}
const CreatedByYou = ({ myPaymentLinks, getMyPaymentsLinks }: Props) => {
    return (
        <>
            <TablePaymentLinks className="my-links">
                <thead>
                    <tr>
                        <th>Data de criação</th>
                        <th>Nome cobrança</th>
                        <th>Pagador</th>
                        <th>
                            CPF/CNPJ <br />
                            (Quem paga)
                        </th>
                        <th>Data liquidação</th>
                        <th>Valor</th>
                        {/* <th>N. Parcelas</th> */}
                        <th>Status</th>
                        <th className="link">Link</th>
                        <th className="">Ações</th>
                        <th>Tipo</th>
                    </tr>
                </thead>

                <tbody>
                    {myPaymentLinks.map((link) => (
                        <PaymentLinkRow
                            key={link.id}
                            link={link}
                            getMyPaymentsLinks={getMyPaymentsLinks}
                        />
                    ))}
                </tbody>
            </TablePaymentLinks>
        </>
    )
}
interface PaymentLinkRowProps {
    link: any
    getMyPaymentsLinks: () => Promise<void>
}
function PaymentLinkRow({ link, getMyPaymentsLinks }: PaymentLinkRowProps) {
    const { cnpj_cpf } = useSelector((state: StoreState) => state.auth.user)
    const [isLoading, setIsLoading] = useState(false)

    const [showModalDeleteLink, setShowModalDeleteLink] = useState(false)

    const navigate = useNavigate()
    function handleCopy(linkId: string) {
        // navigator.clipboard.writeText(linkId)
        const linkCobranca = `${process.env.REACT_APP_BILLING_URL}/${linkId}`
        navigator.clipboard.writeText(linkCobranca)
        toast.success('Link copiado!')
    }

    const handleDelete = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        setIsLoading(true)
        try {
            await api.post('/cobranca/deletar', {
                cnpj_cpf,
                identificadorCobranca: link.id,
            })
            swal({
                title: 'Cobrança deletada com sucesso!',
                icon: 'success',
            })
            await getMyPaymentsLinks()
        } catch (error) {
            const messageError = get(error, 'response.data.error', '')
            swal({
                title: 'Erro ao deletar cobrança.',
                text: `${messageError}`,
                icon: 'error',
            })
        } finally {
            setShowModalDeleteLink(false)
            setIsLoading(false)
        }
    }
    return (
        <>
            <tr key={link.id}>
                <td
                    onClick={() =>
                        navigate(`/cobranca/${link.id}?criadorCobranca=true`)
                    }
                >
                    {dayjs(link.createdAt).format('DD/MM/YYYY - HH:mm:ss')}
                </td>
                <td
                    onClick={() =>
                        navigate(`/cobranca/${link.id}?criadorCobranca=true`)
                    }
                >
                    {link.nomeLink}
                </td>
                <td
                    onClick={() =>
                        navigate(`/cobranca/${link.id}?criadorCobranca=true`)
                    }
                >
                    {link.nomePagador}
                </td>
                <td
                    onClick={() =>
                        navigate(`/cobranca/${link.id}?criadorCobranca=true`)
                    }
                >
                    {cnpjCpfMask(link.cnpjPagador)}
                </td>
                <td
                    onClick={() =>
                        navigate(`/cobranca/${link.id}?criadorCobranca=true`)
                    }
                >
                    {parseDate(link.dataLiquidacao, true)}
                </td>
                <td
                    onClick={() =>
                        navigate(`/cobranca/${link.id}?criadorCobranca=true`)
                    }
                >
                    {Number(link.valor).toLocaleString('pt-br', {
                        style: 'currency',
                        currency: 'BRL',
                    })}
                </td>
                {/* <td onClick={() => navigate(`/link/${link.id}?criadorCobranca=false`)} >{link.quantParcelas} parcelas</td> */}
                <td
                    onClick={() =>
                        navigate(`/cobranca/${link.id}?criadorCobranca=true`)
                    }
                >
                    {link.situacao}
                </td>
                <td className="link" onClick={() => handleCopy(link.id)}>
                    <div className="flex items-center gap-1">
                        Copiar link <FiCopy color="#333" size={18} />
                    </div>
                </td>
                <td className="">
                    {link.situacao === 'Aguardando pagamento' ? (
                        <button
                            disabled={isLoading}
                            onClick={() => setShowModalDeleteLink(true)}
                            className="px-2 py-1 border-solid rounded-md border shadow-sm flex items-center hover:bg-gray-500/20"
                        >
                            {isLoading ? (
                                <BiLoaderAlt className="shrink-0 animate-spin w-4 h-4" />
                            ) : (
                                <BiTrash className="shrink-0 text-red-500 w-4 h-4" />
                            )}
                        </button>
                    ) : null}
                </td>
                {/* <td className='tipo' onClick={() => navigate(`/link/${link.id}?criadorCobranca=true`)} >{link.tipoLink === 0 ? 'P' : 'R'}</td> */}
                <td
                    className="tipo"
                    onClick={() =>
                        navigate(`/cobranca/${link.id}?criadorCobranca=true`)
                    }
                >
                    {link.tipoLink === 0 && (
                        <BiDollarCircle color="#333" size={22} />
                    )}
                    {link.tipoLink === 1 && (
                        <RiExchangeDollarLine color="#333" size={22} />
                    )}
                    {link.tipoLink === 2 && (
                        <HiOutlineReceiptPercent color="#333" size={22} />
                    )}
                </td>
            </tr>
            <Dialog
                open={showModalDeleteLink}
                TransitionComponent={Transition}
                keepMounted
                onClose={() => setShowModalDeleteLink(false)}
                aria-describedby="alert-dialog-link-delete"
            >
                <DialogTitle>Deletar cobrança</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-link-delete">
                        Tem certeza que deseja deletar esta cobrança?
                    </DialogContentText>
                    <form onSubmit={handleDelete}>
                        <DialogActions>
                            <Button
                                disabled={isLoading}
                                onClick={() => setShowModalDeleteLink(false)}
                            >
                                Cancelar
                            </Button>
                            <Button
                                disabled={isLoading}
                                className="flex items-center"
                                type="submit"
                            >
                                {isLoading && (
                                    <BiLoaderAlt className="mr-2 shrink-0 animate-spin w-4 h-4" />
                                )}
                                Sim, deletar
                            </Button>
                        </DialogActions>
                    </form>
                </DialogContent>
            </Dialog>
        </>
    )
}

export default CreatedByYou
